import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";
import { articles, categories } from "@/mocks/gossip";

export default function Hero({ onSearch }: { onSearch: (q: string) => void }) {
  const [kw, setKw] = useState("");
  const top = [...articles].sort((a, b) => b.heat - a.heat)[0];

  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearch(kw.trim());
  };

  return (
    <section className="relative w-full overflow-hidden bg-background-50">
      {/* 装饰 */}
      <div className="pointer-events-none absolute -right-20 top-0 hidden select-none font-heading text-[16rem] font-black leading-none text-primary-50 lg:block">
        瓜
      </div>
      <div className="pointer-events-none absolute right-32 top-14 hidden h-40 w-40 rounded-full bg-accent-100/70 blur-2xl lg:block"></div>

      <div className="relative mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-10 px-4 py-10 md:px-8 md:py-16 lg:grid-cols-12 lg:gap-8 lg:px-12">
        {/* 文案列 */}
        <div className="lg:col-span-6">
          <div className="inline-flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            <span className="text-xs font-semibold text-foreground-700">
              海角吃瓜 · 每日瓜报 · 2026年9月9日 更新
            </span>
          </div>

          <h2 className="mt-6 font-heading text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-5xl xl:text-6xl">
            今日最热瓜单
            <br />
            一次<span className="relative text-primary-600">吃到饱</span>
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600">
            聚合最新娱乐爆料、综艺名场面、影视热映与乐坛动态，按热度整理吃瓜合集与大盘点，帮你第一时间接上圈内新鲜事与高赞讨论，追更再也不掉队。
          </p>

          {/* 搜索 */}
          <form
            role="search"
            onSubmit={submit}
            className="mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
          >
            <label className="sr-only" htmlFor="search">搜索瓜料</label>
            <input
              id="search"
              type="search"
              name="keyword"
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              placeholder="搜索想看的瓜，如：综艺、影视、悬疑……"
              className="h-12 flex-1 rounded-full border border-background-300 bg-background-100 px-5 text-sm text-foreground-950 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
            <button
              type="submit"
              className="inline-flex h-12 cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-line" aria-hidden="true"></i>
              搜瓜料
            </button>
          </form>

          {/* 分类快捷入口 */}
          <div className="mt-8 flex flex-wrap items-center gap-2">
            <span className="text-xs font-medium text-foreground-500">快捷频道：</span>
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3.5 py-1.5 text-xs font-semibold whitespace-nowrap text-secondary-900 transition-colors hover:bg-accent-200 hover:text-accent-900"
              >
                <i className="ri-hashtag" aria-hidden="true"></i>
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        {/* 主打卡片 */}
        <div className="lg:col-span-6">
          <Link
            to={`/detail/${top.id}`}
            className="group relative block h-[340px] w-full overflow-hidden rounded-3xl md:h-[440px]"
          >
            <img
              src={top.image}
              alt={top.title}
              className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5 md:p-7">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                  <i className="ri-fire-fill" aria-hidden="true"></i> 热度 {top.heat}
                </span>
                <span className="rounded-full bg-background-50/20 px-2.5 py-1 text-xs font-semibold text-background-50 backdrop-blur">
                  本期主打
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                {top.title}
              </h3>
              <p className="mt-2 hidden text-sm leading-relaxed text-background-200/90 md:block">
                {top.summary}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs text-background-200/80">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" aria-hidden="true"></i> {top.views} 阅读
                </span>
                <span className="flex items-center gap-1 whitespace-nowrap">
                  <i className="ri-time-line" aria-hidden="true"></i> {top.date}
                </span>
                <span className="ml-auto inline-flex items-center gap-1 rounded-full border border-background-50/40 px-3 py-1 text-background-50 transition-colors group-hover:bg-background-50 group-hover:text-foreground-950">
                  立即吃瓜 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}